@if (potential_client) {
  <div id="content">
    <div class="page-title">
      <h1>Cliente potencial: {{ potential_client.full_name }}</h1>
      <button mat-flat-button [routerLink]="['..']" [queryParams]="queryParamBackObject">
        <mat-icon>arrow_back</mat-icon>
        Volver
      </button>
      <button mat-flat-button color="accent" (click)="openChangeStatusDialog()">
        <mat-icon>refresh</mat-icon>
        Actualizar estado
      </button>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                <h2>Detalle</h2>
                <p class="subtitle">{{ potential_client.potential_client_status.name }}</p>
              </div>
              <button mat-flat-button color="accent" (click)="openEditDialog()">
                <mat-icon>edit</mat-icon>
                Editar datos
              </button>
            </div>
            <div class="container">
              <div class="row">
                <div class="col-12 col-lg-4">
                  <p class="title">Nombre</p>
                  <p class="value">{{ potential_client.full_name }}</p>
                </div>
                <div class="col-12 col-lg-4">
                  <p class="title">Empresa</p>
                  <p class="value">{{ potential_client.company_name || '-' }}</p>
                </div>
                <div class="col-12 col-lg-4">
                  <p class="title">Correo electrónico</p>
                  <p class="value">{{ potential_client.email || '-' }}</p>
                </div>
                <div class="col-12 col-lg-4">
                  <p class="title">Teléfono</p>
                  <p class="value" style="display: flex; align-items: center; gap: 0.5rem; flex-wrap: wrap">
                    <span>{{ potential_client.phone || '-' }}</span>
                    @if (potential_client.phone && canUseRingover) {
                      <button mat-stroked-button color="accent" type="button" (click)="callLead()">
                        <mat-icon>dialpad</mat-icon>
                        Llamar
                      </button>
                    }
                  </p>
                </div>
                <div class="col-12 col-lg-4">
                  <p class="title">Estado</p>
                  <p class="value">
                    <span class="status-badge" [attr.data-status]="potential_client.potential_client_status_slug">{{
                      potential_client.potential_client_status.name
                    }}</span>
                  </p>
                </div>
                <div class="col-12 col-lg-4">
                  <p class="title">Origen</p>
                  <p class="value">{{ potential_client.origin?.name || '-' }}</p>
                </div>
                @if (
                  potential_client.meta_ad_id ||
                  potential_client.meta_ad_name ||
                  potential_client.meta_form_id ||
                  potential_client.meta_form_submitted_at
                ) {
                  <div class="col-12 col-lg-4">
                    <p class="title">Anuncio Meta</p>
                    <p class="value">
                      {{ potential_client.meta_ad_name || potential_client.meta_ad_id || '-' }}
                      @if (potential_client.meta_ad_name && potential_client.meta_ad_id) {
                        <span class="text-muted"> ({{ potential_client.meta_ad_id }})</span>
                      }
                    </p>
                  </div>
                  @if (potential_client.meta_campaign_name) {
                    <div class="col-12 col-lg-4">
                      <p class="title">Campaña Meta</p>
                      <p class="value">{{ potential_client.meta_campaign_name }}</p>
                    </div>
                  }
                  <div class="col-12 col-lg-4">
                    <p class="title">Formulario Meta</p>
                    <p class="value">{{ potential_client.meta_form_id || '-' }}</p>
                  </div>
                  @if (potential_client.meta_form_submitted_at) {
                    <div class="col-12 col-lg-4">
                      <p class="title">Enviado formulario Meta</p>
                      <p class="value">{{ potential_client.meta_form_submitted_at | date: 'short' }}</p>
                    </div>
                  }
                }
                <div class="col-12 col-lg-4">
                  <p class="title">Comercial asignado</p>
                  <p class="value">{{ potential_client.commercial.name + ' ' + potential_client.commercial.surnames }}</p>
                </div>
                <div class="col-12 col-lg-4">
                  <p class="title">Facturación anual aprox.</p>
                  <p class="value">
                    {{
                      potential_client.approximate_company_annual_billing_in_millions != null
                        ? potential_client.approximate_company_annual_billing_in_millions + ' M€'
                        : '-'
                    }}
                  </p>
                </div>
                @if (potential_client.rejection_reason) {
                  <div class="col-12 col-lg-4">
                    <p class="title">Motivo de rechazo</p>
                    <p class="value">{{ rejectionLabel(potential_client.rejection_reason) }}</p>
                  </div>
                  <div class="col-12 col-lg-8">
                    <p class="title">Justificación</p>
                    <p class="value">{{ potential_client.rejection_justification || '-' }}</p>
                  </div>
                }
                @if (potential_client.standby_notify_at) {
                  <div class="col-12 col-lg-4">
                    <p class="title">Notificar standby</p>
                    <p class="value">{{ potential_client.standby_notify_at | date: 'dd/MM/yyyy' }}</p>
                  </div>
                }
                <div class="col-12">
                  <p class="title">Descripción</p>
                  <p class="value description-value">{{ potential_client.description || '-' }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                <h2>Acciones comerciales</h2>
                <p class="subtitle">Historial de acciones rápidas registradas</p>
              </div>
              <div class="pc-action-icons">
                @for (actionType of quickActionTypes; track actionType.value) {
                  <button
                    type="button"
                    class="pc-action-chip"
                    [ngClass]="'type-' + actionType.value"
                    [class.done]="actionCount(actionType.value) > 0"
                    [matTooltip]="actionType.label"
                    (click)="registerAction(actionType.value)"
                  >
                    <span class="pc-action-count">{{ actionCount(actionType.value) }}</span>
                    @if (actionType.icon === 'whatsapp') {
                      <svg class="pc-action-svg" viewBox="0 0 24 24" aria-hidden="true">
                        <path
                          fill="currentColor"
                          d="M17.47 14.38c-.29-.15-1.72-.85-1.98-.95-.27-.1-.46-.15-.66.15-.2.29-.76.95-.93 1.14-.17.2-.34.22-.63.07-.29-.15-1.22-.45-2.33-1.44-.86-.77-1.44-1.72-1.61-2.01-.17-.29-.02-.45.13-.6.13-.13.29-.34.44-.51.15-.17.2-.29.29-.49.1-.2.05-.37-.02-.52-.07-.15-.66-1.59-.9-2.18-.24-.57-.48-.49-.66-.5h-.56c-.2 0-.52.07-.79.37-.27.29-1.04 1.02-1.04 2.48s1.07 2.88 1.22 3.08c.15.2 2.1 3.2 5.08 4.49.71.31 1.26.49 1.69.63.71.23 1.36.2 1.87.12.57-.09 1.72-.7 1.96-1.38.24-.68.24-1.26.17-1.38-.07-.12-.26-.2-.55-.34zM12.04 21.8h-.01a9.78 9.78 0 0 1-4.98-1.36l-.36-.21-3.7.97 1-3.61-.24-.37a9.76 9.76 0 0 1-1.5-5.21C2.25 6.34 6.6 2 11.99 2c2.61 0 5.06 1.02 6.91 2.87A9.7 9.7 0 0 1 21.75 12c0 5.4-4.39 9.8-9.71 9.8zm8.41-17.2A11.55 11.55 0 0 0 12 0C5.45 0 .12 5.33.12 11.88c0 2.09.55 4.14 1.59 5.94L0 24l6.34-1.66a11.86 11.86 0 0 0 5.66 1.44h.01c6.55 0 11.88-5.33 11.88-11.88 0-3.17-1.24-6.16-3.48-8.4z"
                        />
                      </svg>
                    } @else {
                      <mat-icon>{{ actionType.icon }}</mat-icon>
                    }
                  </button>
                }
              </div>
            </div>
            <div class="bisual-table">
              <div class="bisual-table-row-header">
                <div class="bisual-table-col">Tipo</div>
                <div class="bisual-table-col">Usuario</div>
                <div class="bisual-table-col">Fecha</div>
              </div>
              @if (potential_client.potential_client_actions?.length) {
                @for (action of potential_client.potential_client_actions; track action.id) {
                  <div class="bisual-table-row">
                    <div class="bisual-table-col">{{ actionLabel(action.type) }}</div>
                    <div class="bisual-table-col">
                      {{ action.user ? action.user.name + ' ' + action.user.surnames : '-' }}
                    </div>
                    <div class="bisual-table-col">{{ action.created_at | date: 'short' }}</div>
                  </div>
                }
              } @else {
                <div class="bisual-table-row">
                  <div class="bisual-table-col" style="grid-column: 1 / -1">Todavía no hay acciones registradas.</div>
                </div>
              }
            </div>
          </div>
        </div>

        <div class="col-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                <h2>Actas de reunión</h2>
                <p class="subtitle">Registra aquí todas las actas de las reuniones que tengas con el cliente</p>
              </div>
              <button mat-flat-button color="accent" [routerLink]="['meeting-records']">
                <mat-icon>add</mat-icon>
                Crear acta de reunión
              </button>
            </div>
            <div class="bisual-table" id="meetings-table">
              <div class="bisual-table-row-header">
                <div class="bisual-table-col">Concepto</div>
                <div class="bisual-table-col">Fecha</div>
                <div class="bisual-table-col">Asistentes</div>
                <div class="bisual-table-col"></div>
              </div>
              @for (record of potential_client.meeting_records; track record) {
                <div class="bisual-table-row">
                  <div class="bisual-table-col">{{ record.title }}</div>
                  <div class="bisual-table-col">{{ record.date | date: 'short' }}</div>
                  <div class="bisual-table-col">{{ '??' }}</div>
                  <div class="bisual-table-col">
                    <ng-container matColumnDef="actions">
                      <th mat-header-cell *matHeaderCellDef></th>
                      <td mat-cell>
                        <button mat-icon-button [matMenuTriggerFor]="menu">
                          <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #menu="matMenu">
                          <button mat-menu-item [routerLink]="['meeting-records', record.id]">
                            <mat-icon style="margin-right: 10px">edit</mat-icon>
                            Editar acta
                          </button>
                          <button mat-menu-item (click)="deleteMeetingRecord(record.id)">
                            <mat-icon style="margin-right: 10px">delete</mat-icon>
                            Eliminar acta
                          </button>
                        </mat-menu>
                      </td>
                    </ng-container>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                <h2>Comentarios</h2>
                <p class="subtitle">Deja tus comentarios para ayudar a tus compañeros a mantener el estado de la situación.</p>
              </div>
            </div>
            <div class="bisual-table" id="comments-table">
              <div class="bisual-table-row-header">
                <div class="bisual-table-col">Autor</div>
                <div class="bisual-table-col">Contenido</div>
                <div class="bisual-table-col">Fecha</div>
              </div>
              @for (comment of potential_client.potential_client_comments; track comment) {
                <div class="bisual-table-row">
                  <div class="bisual-table-col">{{ comment.author.name + ' ' + comment.author.surnames }}</div>
                  <div class="bisual-table-col comment-content" [innerHTML]="comment.content | trustedHtml"></div>
                  <div class="bisual-table-col">{{ comment.created_at | date: 'short' }}</div>
                </div>
              }
              <div class="bisual-table-row" id="addCommentRow" [formGroup]="addCommentFormGroup">
                <div class="bisual-table-col comment-editor-col">
                  <editor
                    formControlName="content"
                    [apiKey]="tinyMceApiKey"
                    cloudChannel="6"
                    id="potential-client-comment-editor"
                    [init]="tiny_mce_comment_init"
                    initialValue=""
                    [inline]="false"
                    tagName="div"
                  ></editor>
                </div>
                <div class="bisual-table-col">
                  <button mat-flat-button color="accent" type="button" [disabled]="!addCommentFormGroup.valid" (click)="addComment()">
                    <mat-icon>add</mat-icon>
                    Añadir comentario
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                <h2>Histórico</h2>
                <p class="subtitle">Observa los cambios y los pasos que se han seguido con este cliente.</p>
              </div>
            </div>
            <div class="bisual-table" id="historic-table">
              <div class="bisual-table-row-header">
                <div class="bisual-table-col">Actualizador</div>
                <div class="bisual-table-col">Cambio</div>
                <div class="bisual-table-col">Fecha</div>
              </div>
              @for (record of potential_client.potential_client_status_change_records; track record) {
                <div class="bisual-table-row">
                  <div class="bisual-table-col">{{ record.user.name + ' ' + record.user.surnames }}</div>
                  <div class="bisual-table-col">
                    @if (record.old_status_slug == null) {
                      <span class="status-badge" [attr.data-status]="record.new_status_slug">{{ record.new_status.name }}</span>
                    } @else {
                      <span class="status-badge" [attr.data-status]="record.old_status_slug">{{ record.old_status.name }}</span>
                      <mat-icon>trending_flat</mat-icon>
                      <span class="status-badge" [attr.data-status]="record.new_status_slug">{{ record.new_status.name }}</span>
                    }
                  </div>
                  <div class="bisual-table-col">{{ record.created_at | date: 'short' }}</div>
                </div>
              }
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="card locations-card">
            <app-locations-management [relatable_type]="potential_client_relatable_type" [relatable_id]="potential_client.id" />
          </div>
        </div>
      </div>
    </div>
  </div>
}
